import { reactive } from 'vue';

// Estado singleton compartilhado entre todas as bolhas para o modo de
// selecao multipla (encaminhar varias mensagens de uma vez).
const state = reactive({
  active: false,
  conversationId: null,
  ids: [],
});

export function useMessageForwardSelection() {
  const start = (conversationId, messageId = null) => {
    state.active = true;
    state.conversationId = conversationId;
    state.ids = messageId != null ? [messageId] : [];
  };

  const toggle = messageId => {
    const idx = state.ids.indexOf(messageId);
    if (idx >= 0) state.ids.splice(idx, 1);
    else state.ids.push(messageId);
  };

  const isSelected = messageId => state.ids.includes(messageId);

  const clear = () => {
    state.active = false;
    state.conversationId = null;
    state.ids = [];
  };

  return { state, start, toggle, isSelected, clear };
}
